import { Analytics, AllowableJourneys } from '@acorn/analytics';
import posthogClient from './posthog-client';

const portals = ['acorn', 'carrot', 'motorcade', 'flag', 'mypolicy', 'street-cover'] as const;

const analytics = new Analytics<AllowableJourneys>({
	posthogClient,
}).withJourneys(portals);
export default analytics;
